<template>
  <div class="fill-height">
    <v-layout
      v-if="tabs"
      class="tabs text-uppercase content-bg--3 font-weight-bold"
    >
      <v-flex
        @click="tabActive = 0"
        :class="{ 'primary--text tabs-active': tabActive === 0 }"
        class="text-xs-center link pb-1"
      >
        Ваш менеджер
      </v-flex>
      <v-flex
        @click="tabActive = 1"
        :class="{ 'primary--text tabs-active': tabActive === 1 }"
        class="text-xs-center link pb-1"
      >
        Задать вопрос
      </v-flex>
    </v-layout>

    <div :class="{ 'px-4': tabs }" class="fill-height">
      <div v-if="!tabs || (tabs && tabActive === 0)">
        <div v-if="!tabs" class="display-3 font-weight-bold pb-2 mb-4">
          Ваш менеджер
        </div>
        <img
          v-if="manager.avatar"
          :src="manager.avatar"
          :class="{ 'mt-4': tabs }"
        />
        <div class="display-1 font-weight-bold pb-3 mt-4">
          {{ manager.name }}
        </div>
        <div class="font-weight-medium">
          <div v-if="manager.phone">тел.: {{ manager.phone }}</div>
          <div v-if="manager.email">e-mail: {{ manager.email }}</div>
        </div>
      </div>

      <hr v-if="!tabs" class="my-4" />

      <div v-if="!tabs || (tabs && tabActive === 1)">
        <div v-if="!tabs" class="display-1 font-weight-bold">Задать вопрос</div>
        <div v-if="error" class="error--text pt-3">{{ error }}</div>
        <v-form
          v-model="formValid"
          @keyup.native.enter="send"
          ref="form"
          class="pt-3"
        >
          <label>Текст вопроса</label>
          <v-textarea
            v-model="formParams.message"
            :rules="[rules.required]"
            placeholder="Введите текст"
            textarea
            solo
          ></v-textarea>

          <label>Телефон</label>
          <v-text-field
            v-model="formParams.phone"
            :rules="[rules.required]"
            prefix="+7"
            height="42"
            mask="phone"
            return-masked-value
            solo
            placeholder="(___) ___ - ____"
          ></v-text-field>

          <label>Имя</label>
          <v-text-field
            v-model="formParams.name"
            :rules="[rules.required]"
            height="42"
            solo
            placeholder="Имя"
          ></v-text-field>

          <v-btn @click="send" class="primary my-4">
            Отправить
          </v-btn>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";

export default {
  name: "SupportForm",

  components: {},

  props: {
    tabs: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    error: null,
    tabActive: 0,
    formValid: false,
    rules: {
      required: v => !!v || "Поле обязательно для заполнения"
    },
    formParams: {}
  }),

  computed: {
    manager() {
      return this.$store.getters.user.manager;
    }
  },

  methods: {
    send() {
      this.error = null;
      if (this.$refs.form.validate()) {
        RequestApi.sendMessage({
          ...this.formParams,
          phone: `+7 ${this.formParams.phone}`,
          deptName: this.manager.deptName
        })
          .then(() => {
            // открываем сообщение
            this.$store
              .dispatch("popupInfoOpen", {
                timeout: 3000,
                text: "Сообщение успешно отправлено"
              })
              .then(() => {
                this.$refs.form.reset();
                this.$emit("closeSecondPanel");
              });

            // событие в метрике
            Common.sendMetrika("support");
          })
          .catch(err => {
            this.error = err;
          });
      }
    }
  }
};
</script>
